<template>
  <div class="wrapper-setting">
    <div class="col">
      <el-row>
        <el-col :span="5">
          <div class="bg-white min-height">
            <home-sidebar active_item="spend"></home-sidebar>
          </div>
        </el-col>
        <el-col :span="19">
          <div class="bg-white ml-3 min-height">
            <div class="p-3">
              <div class="content-box">
                <div class="title">消费记录
                </div>
                <div class="content">
                  <label class="item_w">消耗金币：{{ this.page.total }}枚</label>
                  <label class="item_w">账户余额：{{ this.remain }}元</label>
                </div>
                <div class="content">
                  <label class="item_w">{{ this.msgTitle }}</label>
                </div>
                <div class="">
                  <!--列表-->
                  <el-table stripe :data="dataList" border highlight-current v-loading="listLoading"
                            ref="multipleTable" @selection-change="selsChange">
                    <el-table-column type="selection"></el-table-column>
                    <el-table-column prop="userId" label="用户" width="120"></el-table-column>
                    <el-table-column prop="traceNo" label="订单号" width=""></el-table-column>
                    <el-table-column prop="message" label="状态" width="160"></el-table-column>
                    <el-table-column prop="totalAmount" label="金额" width="80"></el-table-column>
                    <el-table-column prop="addtime" label="时间" width="200"></el-table-column>
                    <el-table-column prop="status" label="状态" width="80"></el-table-column>
                    <el-table-column label="操作" width="70px">
                      <template slot-scope="scope">
                        <el-button size="mini" icon="el-icon-edit" type="warning"
                                   @click="handleEdit(scope.row,scope.$index)">
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                  <!--分页-->
                  <div class="toolbar">
                    <el-pagination layout="total,prev, pager, next" @current-change="handleCurrentChange"
                                   :page-size="this.page.size" :total="this.page.total"
                                   :current-page="this.page.index+1"
                                   style="float:right;margin-bottom:20px;">
                    </el-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import api from "../../api/rest";
import util from "../../api/util";
import HomeSidebar from "../../components/HomeSidebar.vue";

export default {
  components: {HomeSidebar},
  data() {
    return {
      page: {
        total: 0,
        size: 20,
        index: 0
      },
      listLoading: false,
      dataList: [],
      remain: 0,
      msgTitle: ""
    }
  },
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    selsChange(val) {

    },
    handleCurrentChange(val) {

    },
    init_page() {
      let api_url = '/payment/list'
      let para = this.page;
      this.listLoading = true
      // 检查是否登录
      api.remote.doPost(para, api_url).then((res) => {
        // console.log(res.remain)
        this.dataList = res.content
        this.page.total = res.totalElements
        this.listLoading = false
      })
    }
  },
  filters: {
    formatMoney(num) {
      num = num / 10000
      return num.toString().replace(/\d+/, function (n) {
        return n.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
      }) + "万";
    },
    formatDateTime(time) {
      var date = new Date(time)
      return date.format("yyyy-MM-dd")
    }
  },
  mounted() {
    this.init_page()
  }
}
</script>


// WEBPACK FOOTER //
// Spend.vue?43d557bc